import { useAppConfiguration } from '@mews-commander/data-access';
import { ImageResizeMode } from '@mews/enums';
import { RouterService } from '@mews/framework';

export const useAvatarSrc = (imageId: string | null | undefined) => {
    const { imageBaseUrl } = useAppConfiguration();

    if (!imageId) {
        return '';
    }

    return RouterService.imageUrl(imageId, imageBaseUrl, { mode: ImageResizeMode.CoverExact });
};
